import { NavigationGuard } from 'vue-router';
import store from '@/store';
import { redirect } from '@/helpers/redirects';
import { getBookingsUrlWithNotification } from '@/helpers/bookings/bookingsUrlHelper';

const validateSitterUuid: NavigationGuard = (to, _from, next) => {
  const sitterUuid = to.params.sitter_uuid;
  const account = store.getters['account/getAccount'];
  const accountKind = account?.accountKind();

  // Check if sitter UUID is missing
  if (!sitterUuid) {
    redirect(getBookingsUrlWithNotification('Sitter profile could not be found', accountKind));
    return;
  }

  // Basic UUID format validation (8-4-4-4-12 hex characters)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (!uuidRegex.test(sitterUuid as string)) {
    redirect(getBookingsUrlWithNotification('Invalid sitter profile', accountKind));
    return;
  }

  next();
};

export default validateSitterUuid;
